<template>
  <div>
    <!-- <van-collapse v-model="activeNames">
      <van-collapse-item name="1">
        <template #title>
          <div class="title-flex">
            <van-image width="20" height="20" :src="icon_title" />
            <span>客户数据统计</span>
          </div>
        </template> -->
        <div class="sectionList">
          <van-grid clickable :column-num="2" style="width: 100%">
            <van-grid-item v-for="item in gridList" :key="item.component" @click="toStatistics(item.component)">
              <div class="center">
                <van-image :src="item.meta.mobileIcon" class="Statistics_img" />
                <div class="Statistics_title">{{item.meta.title}}</div>
              </div>
              <!-- <div class="num">{{item.num}}</div> -->
            </van-grid-item>
            <!-- <van-grid-item v-if="accountBalance" @click="toStatistics('/fina/reportStatistics/accountBalance')">
              <div class="center">
                <van-image :src="require('../../assets/images/tj/company.png')" class="Statistics_img" />
                <div class="Statistics_title">账户余额</div>
              </div>
            </van-grid-item> -->
          </van-grid>
        </div>
      <!-- </van-collapse-item>
    </van-collapse> -->
  </div>
</template>

<script>
import {
  Collapse,
  CollapseItem,
  Icon,
  Grid,
  GridItem,
  Image as VanImage
} from 'vant'
// import { listStatistical } from '@/api/tongji/index'
import { getRoutersNew } from '@/api/auth/auth.js'
export default {
  name: 'TongjiIndex',
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Icon.name]: Icon,
    [Grid.name]: Grid,
    [VanImage.name]: VanImage,
    [GridItem.name]: GridItem
  },
  props: {},
  data() {
    return {
      routerList: [],
      gridList: [
        // {
        //   icon: require('../../assets/images/tj/performance.png'),
        //   title: '业绩统计',
        //   url: '/tongji/perfcons'
        // },
        // {
        //   icon: require('../../assets/images/tj/advance.png'),
        //   title: '垫款统计',
        //   url: '/tongji/advance'
        // },
        // {
        //   icon: require('../../assets/images/tj/scrm.png'),
        //   title: '客户统计',
        //   url: '/tongji/scrm'
        // },
        // {
        //   icon: require('../../assets/images/tj/contract.png'),
        //   title: '合同统计',
        //   url: '/tongji/contract'
        // }

        // {
        //   icon: require('../../assets/images/tj/performance.png'),
        //   title: '事业部业绩统计',
        //   url: '/fina/reportStatistics/performance'
        // },
        // {
        //   icon: require('../../assets/images/tj/company.png'),
        //   title: '公司账户余额统计',
        //   url: '/fina/reportStatistics/accountBalance'
        // }
      ]
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.init()

    getRoutersNew({ sysType: 2 }).then((res) => {
      if (res.code === 200 && res.data.length === 1) {
        this.routerList = res.data
        this.gridList = res.data[0].children
      }
    })
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = '统计'
      // listStatistical().then((response) => {
      //   console.log(response)
      //   // boCount 商机  clueCount 线索 orderCount 订单 toTrackCount 待跟踪
      //   const data = response.data
      //   const gridList = this.gridList
      //   gridList[0].num = data.clueCount
      //   gridList[1].num = data.orderCount
      //   gridList[2].num = data.boCount
      //   gridList[3].num = data.toTrackCount
      //   this.$forceUpdate()
      // })
    },
    toStatistics(url) {
      this.$router.push({
        path: url
      })
    }
  }
}
</script>

<style scoped lang='less'>
// /deep/ .van-collapse-item__content {
//   padding: 0 !important;
// }
// .title-flex {
//   display: flex;

//   span {
//     margin-left: 20px;
//     font-weight: bold;
//   }
// }

.sectionList {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  .center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .Statistics_img{
      width: 160px;
      height: 160px;
    }
    .Statistics_title{
      margin-top: 20px;
      font-size: 32px;
      color: #1E90FF;
      font-weight: bold;
    }
  }
  // .num {
  //   margin-top: 20px;
  //   font-size: 40px;
  //   color: #1ab25f;
  //   font-weight: bold;
  // }

  // .sec {
  //   font-size: 25px;
  //   font-weight: bold;
  //   color: #646464;

  //   span {
  //     font-size: 30px;
  //     margin-left: 10px;
  //   }
  // }
}
</style>
